import { ArgError } from '../errors';
import type { GridType } from '../commons/constants';

const FORBIDDEN_KEYS = ['platformName', 'platform', 'app', 'bundleId', 'appPackage', 'extensions'];
const LT_FORBIDDEN_KEYS = ['selenium_version', 'protocol', 'host', 'port', 'path', 'build'];

export const checkForbiddenKeys = (capabilities: Record<string, any>, gridType?: GridType): void => {
    const keysToCheck = gridType === 'lambdaTest' ? [...FORBIDDEN_KEYS, ...LT_FORBIDDEN_KEYS] : FORBIDDEN_KEYS;
    const usedForbiddenKeys: string[] = [];
    const toCheck: Record<string, any>[] = [capabilities];

    while (toCheck.length) {
        const caps = toCheck.pop()!;

        for (const [key, value] of Object.entries(caps)) {
            if (keysToCheck.includes(key)) {
                usedForbiddenKeys.push(key);
            }

            if (value && typeof value === 'object') {
                toCheck.push(value);
            }
        }
    }

    if (usedForbiddenKeys.length) {
        throw new ArgError(`Custom capabilities contains forbidden keys: ${usedForbiddenKeys.join(', ')}`);
    }
};
